import { GameObjects } from 'phaser';
import { ARCADE, ARCADE_HEX, ARCADE_TEXT, MOLDURA } from '../config/theme';
import { MolduraPixel } from './MolduraPixel';

const CORES = {
    ligado: { fundo: ARCADE_HEX.VERDE, fio: ARCADE_HEX.VERDE, fioMeio: ARCADE_HEX.BRANCO },
    desligado: { fundo: ARCADE_HEX.BOTAO_OFF, fio: ARCADE_HEX.FIO_OFF, fioMeio: ARCADE_HEX.BOTAO_OFF }
};

/**
 * Botão do tema Figma: moldura pixel verde, rótulo em Silkscreen e ícone
 * opcional à esquerda do rótulo.
 *
 * `variante` decide a aparência do estado desabilitado:
 * - `cinza`: botão de ação que ainda não pode ser usado (Vincular).
 * - `apagado`: atalho indisponível, mesmo verde a 50% (Insights/Materiais).
 * - `cinzaApagado`: ação indisponível sobre fundo lima, cinza a 50% (Conferir).
 */
export class BotaoArcade extends GameObjects.Container {
    constructor (scene, x, y, config = {}) {
        super(scene, x, y);
        scene.add.existing(this);

        const {
            rotulo = '', icone = null, largura = 368, altura = MOLDURA.ALTURA,
            habilitado = true, variante = 'cinza', aoClicar = null,
            cores = null, chanfros = undefined
        } = config;

        this.largura = largura;
        this.altura = altura;
        this.variante = variante;
        this.aoClicar = aoClicar;
        this.cores = cores ?? CORES.ligado;
        this.chanfros = chanfros;
        this.habilitado = false;

        this.moldura = scene.add.graphics();
        this.rotulo = scene.add.text(0, -1, rotulo, ARCADE_TEXT.botao).setOrigin(0.5);
        this.add([this.moldura, this.rotulo]);

        if (icone && scene.textures.exists(icone)) {
            this.icone = scene.add.image(0, 0, icone).setOrigin(0.5);
            this.add(this.icone);
            // Ícone + 12 px + rótulo, centralizados em conjunto.
            const total = this.icone.width + 12 + this.rotulo.width;
            this.icone.x = -total / 2 + this.icone.width / 2;
            this.rotulo.x = total / 2 - this.rotulo.width / 2;
        }

        // Área de toque cobre a moldura inteira (≥ 44×44, AGENTES.md §3).
        this.setSize(largura, altura);
        this.on('pointerdown', () => this.habilitado && this.setScale(0.97));
        this.on('pointerout', () => this.setScale(1));
        this.on('pointerup', () => {
            if (!this.habilitado) return;
            this.setScale(1);
            this.aoClicar?.(this);
        });

        this.setHabilitado(habilitado);
    }

    setHabilitado (habilitado) {
        this.habilitado = Boolean(habilitado);
        this.setScale(1);

        const apagado = !this.habilitado && this.variante === 'apagado';
        const cores = this.habilitado || apagado ? this.cores : CORES.desligado;

        this.moldura.clear();
        MolduraPixel.desenhar(
            this.moldura, -this.largura / 2, -this.altura / 2, this.largura, this.altura, cores,
            this.chanfros
        );
        const cinzaApagado = !this.habilitado && this.variante === 'cinzaApagado';
        this.rotulo.setColor(this.habilitado || apagado || cinzaApagado ? ARCADE.BRANCO : '#ababab');
        this.setAlpha(apagado || cinzaApagado ? 0.5 : 1);

        if (this.habilitado) this.setInteractive({ useHandCursor: true });
        else this.disableInteractive();
        return this;
    }
}
